// src/helpers/clickTracking.js
//
// 카테고리/메뉴 클릭 집계용 fire-and-forget 트래커.
// - 앱 공용 axios 인스턴스(http)를 재사용 → Bearer 토큰 자동 주입(있으면).
// - /web 마운트로 POST 하므로 서버가 device=web 으로 태깅한다.
// - 절대 throw 하지 않고 navigation 을 막지 않는다(모든 에러 swallow).
// - target_key 규칙은 모바일 앱과 동일하게 맞춰 집계가 합쳐지도록 한다.
import { http } from "../api/http.ts";
import { ENDPOINTS } from "../api/endpoints.ts";

// target_type: "category" | "menu" | "nearby_service"
function trackClick(targetType, targetKey, targetLabel) {
  if (!targetType || targetKey == null || targetKey === "") return;

  const body = { target_type: targetType, target_key: String(targetKey) };
  if (targetLabel != null && targetLabel !== "") body.target_label = String(targetLabel);

  // fire-and-forget: await 하지 않고 모든 에러 무시(응답은 항상 200 이지만 방어적으로).
  void http.post(ENDPOINTS.interactions.click, body).catch(() => {});
}

// 홈 카테고리 타일 / CATEGORY 배너 — target_key = 백엔드 카테고리 id, label = 이름.
export function trackCategoryClick(item) {
  if (!item) return;
  trackClick("category", item.id, item.name);
}

// 드로어/헤더 메뉴 — target_key = 안정적인 snake_case slug(현지화 라벨 아님).
export function trackMenuClick(slug, label) {
  if (!slug) return;
  trackClick("menu", slug, label);
}

// 할랄맵 지점 상세의 「근처 즐길거리」 카드 — target_key = 상품 uuid.
//
// 지도 조회가 상품 조회의 7배인데 둘을 잇는 다리가 없어 만든 기능이라, 그 다리가
// 실제로 건너지는지 여기서만 알 수 있다. 이게 없으면 상품 조회가 늘어도 지도
// 덕인지 알 수 없다(결제 이탈에서 겪은 것과 같은 실수를 반복하지 않기 위한 것).
export function trackNearbyServiceClick(service) {
  if (!service?.uuid) return;
  trackClick("nearby_service", service.uuid, service.name);
}
